const CostCenterErrorCodes = {
  CCT00001: 'Nome já está sendo usado por outro centro de custo',
} as const;

export default CostCenterErrorCodes;
